"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDrawer = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../../common");
require("./GKDrawer.css");
/** @deprecated in favor of GKLeftPane within GKLayoutShell */
var GKDrawer = /** @class */ (function (_super) {
    __extends(GKDrawer, _super);
    function GKDrawer(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = function (open) {
            _this.setState({ isOpen: open !== undefined ? open : !_this.state.isOpen });
        };
        _this.state = {
            isOpen: _this.props.open || false,
        };
        return _this;
    }
    GKDrawer.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.open !== prevProps.open) {
            this.setState({ isOpen: this.props.open || false });
        }
    };
    GKDrawer.prototype.render = function () {
        return (React.createElement("div", __assign({}, (0, common_1.mapDefaultProps)(this.props, {
            _gkComponentName: "gk-drawer",
            assignUniqueId: true,
            className: this.state.isOpen ? "open" : "closed",
        }))));
    };
    return GKDrawer;
}(common_1.GKPureComponent));
exports.GKDrawer = GKDrawer;
